<template>
<div class="email-forget">
    <div class="email-inner" v-if="wayType==='email'">
        <div v-show="!has">
            <div class="return" @click="selectWay('email')"></div>
            <div class="fonts title">{{ $t($loginLangPrefix('userSign.forget2')) }}</div>
            <div class="fonts intro">{{ $t($loginLangPrefix('userSign.resettip')) }}</div>
            <div class="fonts email">{{ loginName }}</div>
            <div class="fonts send" :class="{cover: cover}" @click="send()">{{ $t($loginLangPrefix('userSign.confirmSend')) }}</div>
            <p class="fonts inphone" @click="selectWay('phone')" >{{ $t($loginLangPrefix('userSign.phoneTyoe')) }}</p>
        </div>
        <div v-show="has">
            <div class="fonts title">{{ $t($loginLangPrefix('userSign.hasSend')) }}</div>
            <div class="fonts intro">{{ $t($loginLangPrefix('userSign.hasSendTip')) }}</div>
            <div class="fonts send" @click="sure" >{{ $t($loginLangPrefix('userSign.ok')) }}</div>
        </div>
    </div>
    <div class="memail-inner" v-if="wayType==='m-email'">
        <div>
            <!-- <div class="return" @click="selectWay('email')"></div> -->
            <div class="fonts title mb">{{ $t($loginLangPrefix('userSign.forget2')) }}</div>
            <div class="fonts intro mb">{{ $t($loginLangPrefix('userSign.resettip')) }}</div>
            <div class="fonts email mb">{{ loginName }}</div>
            <div class="fonts send mb" :class="{cover: cover}" @click="send()">{{ $t($loginLangPrefix('userSign.confirmSend')) }}</div>
            <p class="fonts inphone mb" @click="selectWay('m-phone')" >{{ $t($loginLangPrefix('userSign.phoneTyoe')) }}</p>
        </div>
        <!-- <div v-show="has">
            <div class="fonts title mb">{{ $t($loginLangPrefix('userSign.hasSend')) }}</div>
            <div class="fonts intro mb">{{ $t($loginLangPrefix('userSign.hasSendTip')) }}</div>
            <div class="fonts send mb" @click="sure" >{{ $t($loginLangPrefix('userSign.ok')) }}</div>
        </div> -->
    </div>

    <toast-pop v-show="toastState" :txt="txt"/>
    <pop-pop v-show="has && wayType==='m-email'" :txt="poptxt" @clickPop="clickPopHandle" />
</div>
</template>
<script>

import api from '../js/api';
import toast from '../common/toast';
import pop from '../common/pop';

export default {
    name: 'emailForget',
    props: {
        loginName: { type: String, default: '' },
        wayType: { type: String, default: '' }
    },
    data() {
        return {
            has: false,
            toastState: false,
            cover: false,
            txt: '',
            poptxt: ''
        };
    },
    components: {
        'toast-pop': toast,
        'pop-pop': pop
    },
    methods: {
        selectWay(type, first) {
            this.$emit('selectWay', type, first);
        },
        send() {
            this.cover = true;
            api.sendEmail(this.loginName, 3, '').then((data) => {
                this.cover = false;
                if (data.ret === '1') {
                    this.has = true;
                    this.poptxt = this.$t(this.$loginLangPrefix('userSign.hasSend'));
                } else {
                    this.showPop(this.$t(this.$loginLangPrefix('userSign.sysError')));
                }
            }).catch((response) => {
                this.cover = false;
                if (response.errorMessageTMXTip) {
                    return;
                }
                this.showPop(this.$t(this.$loginLangPrefix('userSign.sysError')));
            });
        },
        sure() {
            this.selectWay(this.wayType);
        },
        clickPopHandle() {
            this.has = false;
            this.selectWay(this.wayType, true);
        },
        showPop(txt, callback) {
            this.txt = txt;
            this.toastState = true;
            setTimeout(() => {
                this.txt = '';
                this.toastState = false;
                callback && callback();
            }, 1500);
        }
    },

    mounted() {
    },

    beforeDestroy() {
    }
};
</script>
<style lang="scss" scoped>
@function rem($n) {
    @return ($n*1rem / 50);
}
.email-forget {
    position: relative;
    .return {
        position: relative;
        width: 32px;
        height: 32px;
        top: 0;
        left: 0;
        background-image: url('../images/return.png');
        background-repeat: no-repeat;
        background-size: 32px 32px;
        background-position: center center;
        cursor: pointer;
        &.mb {
            width: rem(32);
            height: rem(32);
            background-size: rem(32) rem(32);
        }
    }
    .fonts {
        font-family: 'RobotoRegular';
    }
    .title {
        // width:200px;
        font-weight: normal;
        margin-top: 20px;
        height:33px;
        font-size:24px;
        color:rgba(23,23,23,1);
        line-height:29px;
        &.mb {
            margin-top: rem(78);
            height: rem(33);
            line-height: rem(29);
        }
    }
    .intro {
        margin-top: 8px;
        // height:32px;
        font-size:14px;
        font-weight: normal;
        color:rgba(153,153,153,1);
        line-height:16px;
        &.mb {
            margin-top: rem(8);
            // height: rem(32);
            line-height: rem(16);
        }
    }
    .email {
        margin-top: 30px;
        height:19px;
        font-size:16px;
        font-weight: normal;
        color:rgba(23,23,23,1);
        line-height:19px;
        &.mb {
            margin-top: rem(30);
            height: rem(19);
            line-height: rem(19);
        }
    }
    .send {
        position: relative;
        margin-top: 40px;
        width:100%;
        height:48px;
        background-image: linear-gradient(#9d1dff, #9d1dff);
        border-radius:24px;
        font-size:16px;
        font-family: 'RobotoMedium';
        font-weight:600;
        text-align: center;
        color:rgba(255,255,255,1);
        line-height:48px;
        cursor: pointer;
        transition: background linear .1s;
        &.mb {
            margin-top: rem(40);
            height: rem(48);
            border-radius: rem(24);
            line-height: rem(48);
        }
        &.cover {
            background-blend-mode: multiply;
            background-color: rgba(0, 0, 0, 0.2);
        }
    }
    .inphone {
        margin-top: 10px;
        width: 100%;
        text-align: center;
        font-size:14px;
        font-weight: normal;
        color:rgba(153,153,153,1);
        line-height:14px;
        text-decoration: underline;
        cursor: pointer;
        &.mb {
            margin-top: rem(10);
            line-height: rem(14);
        }
    }
}
</style>
